import {
  HIGHLIGHT,
  PREMIUM,
  CATEGORY,
  TALENTS,
  MOREPOPULAR,
  MORETOP,
  VISIBLE_NUMBER_HIGHLIGHT,
  VISIBLE_NUMBER_PREMIUM,
  VISIBLE_NUMBER_CATEGORY,
  VISIBLE_NUMBER_TALENTS,
  VISIBLE_NUMBER_POPULAR,
  VISIBLE_NUMBER_TOP,
  MUNDIALSOCCERMATCHER,
  MUNDIALSOCCERPLAYER,
  VISIBLE_NUMBER_MUNDIAL_SOCCERMATCHER,
  MUNDIALPLAYERS,
  VISIBLE_NUMBER_PLAYERS,
  LEFT,
  RIGHT,
  NAME_LOCAL_STORAGE_CLICK_TIME_VERTICAL,
  NAME_LOCAL_STORAGE_CLICK_TIME_HORIZONTAL,
  FAST_NAVIGATION_INTERVAL_HORIZONTAL,
  FAST_NAVIGATION_INTERVAL_VERTICAL
} from './constants';
import NpvrUploader from '../../AAF/Npvr/NpvrUploader';
import ChannelSingleton from '../../components/Epg/ChannelsSingleton';
import EpgPersistence from '../../AAF/Nepg/EpgPersistence';
import { Dates } from '../../packages/dates';
import store from './../../store';
import {
  MODAL_RECORD_SERIES_CONTENT,
  showModal
} from "../../actions/modal";
import Utils, {setInitialFocus} from "../../utils/Utils";
import {isActiveFocusDynamic} from "../Focus/utils";
import {navigationLeftSoccer, navigationRightSoccer} from "./functions.mundial";
class GeneralRibbonUtils {
  static blockFastNavigation = (platform) => {
    if (platform) {
      switch (platform) {
        case "hisense": return true;
        case "zeasn": return true;
        case "whaletv": return true;
        case "netrange": return true;
        case "netrangemmh": return true;
        default: return false;
      }
    } else {
      return false;
    }
  }

  static getFocusable = (direction) => {
    const nameStorage = direction === NAME_LOCAL_STORAGE_CLICK_TIME_VERTICAL
      ? NAME_LOCAL_STORAGE_CLICK_TIME_VERTICAL
      : NAME_LOCAL_STORAGE_CLICK_TIME_HORIZONTAL;
    const dataStorage = localStorage.getItem(nameStorage);
    const storagedClickTime = dataStorage ? JSON.parse(dataStorage) : {time: 0, interval: 500};
    const fastNavigationInterval = storagedClickTime.interval;
    const currentClickTime = new Date().getTime();
    const diffClickTime = currentClickTime - storagedClickTime.time;
    const isFocusable = diffClickTime > fastNavigationInterval;

    return {currentClickTime, isFocusable};
  }

  //Move up or down

  static blockFastNavigationDownUp = (platform) => {
    if (platform) {
      switch (platform) {
        case "tizen": return true;
        default: return false;
      }
    } else {
      return false;
    }
  }

  static getDataClicksDownUp = () => {
    const {currentClickTime, isFocusable} = GeneralRibbonUtils.getFocusable(NAME_LOCAL_STORAGE_CLICK_TIME_VERTICAL);

    return {currentClickTime, isFocusable};
  }

  static handleNavigationDownUp = (e, getDirection) => {
    const { currentClickTime, isFocusable} = GeneralRibbonUtils.getDataClicksDownUp()

    const dataStorage = {
      time: currentClickTime,
      interval: isFocusable ? FAST_NAVIGATION_INTERVAL_HORIZONTAL : FAST_NAVIGATION_INTERVAL_VERTICAL
    }

    const dataStorageString = JSON.stringify(dataStorage);

    if (isFocusable) {
      localStorage.setItem(NAME_LOCAL_STORAGE_CLICK_TIME_VERTICAL, dataStorageString);
    }else{
      e.preventDefault();
      e.stopPropagation();
      e.target.removeEventListener('sn:willmove', getDirection);
      localStorage.setItem(NAME_LOCAL_STORAGE_CLICK_TIME_VERTICAL, dataStorageString);
    }
  }

  //Move to the left or right

  static getDataClicks = () => {
    const {currentClickTime, isFocusable} = GeneralRibbonUtils.getFocusable(NAME_LOCAL_STORAGE_CLICK_TIME_HORIZONTAL);

    return {currentClickTime, isFocusable};
  }

  static handleNavigation = ({
                               direction,
                               e,
                               visible,
                               completeItems,
                               setStateVisibles,
                               mundial,
                               visibleNumber,
                               platform,
                               noFocusDynamicBox,
                               ribbonType
                             }) => {

    const validateToChoiceNavigation = noFocusDynamicBox.includes(ribbonType) || (!isActiveFocusDynamic() && ribbonType !== "category")

    const chooseHandlerLeft = validateToChoiceNavigation
      ? GeneralRibbonUtils.navigationLeft
      : GeneralRibbonUtils.handleKeyLeftFocusDynamicBox;

    const chooseHandlerRight = validateToChoiceNavigation
      ? GeneralRibbonUtils.navigationRight
      : GeneralRibbonUtils.handleKeyRightFocusDynamicBox;

    const {currentClickTime, isFocusable} = GeneralRibbonUtils.getDataClicks();

    const chooseHandler = direction === LEFT ? chooseHandlerLeft : chooseHandlerRight;
    const navigationSoccer = direction === LEFT ? navigationLeftSoccer : navigationRightSoccer;

    const dataStorage = {
      time: currentClickTime,
      interval: FAST_NAVIGATION_INTERVAL_HORIZONTAL
    }

    const dataStorageString = JSON.stringify(dataStorage);

    if (GeneralRibbonUtils.blockFastNavigation(platform)) {
      if (isFocusable) {
        mundial
          ? navigationSoccer(visible, completeItems, e)
          : chooseHandler(e, visible, completeItems, visibleNumber, setStateVisibles, ribbonType);
        localStorage.setItem(NAME_LOCAL_STORAGE_CLICK_TIME_HORIZONTAL, dataStorageString);
      } else {
        e.preventDefault();
        return;
      }
    } else {
      mundial
        ? navigationSoccer(visible, completeItems, e)
        : chooseHandler(e, visible, completeItems, visibleNumber, setStateVisibles, ribbonType);
    }
  };

  static getVisibleItems = (items, visibleNumber, movingToLeft = 0) => {
    const visible = [];
    let currentIndex = null;
    if (items) {
      for (let i = 0; i < items.length; i++) {
        items[i].index = i;
        if (items[i].current) {
          currentIndex = i;
          break;
        }
      }
      currentIndex = currentIndex > 0 ? currentIndex - movingToLeft : items.length - movingToLeft;
      if (currentIndex !== null) {
        let fromCurrent = items.slice(currentIndex, currentIndex + visibleNumber);
        if (fromCurrent.length < visibleNumber) {
          const rest = items.slice(0, visibleNumber - fromCurrent.length);
          fromCurrent = fromCurrent.concat(rest);
        }
        for (let i = 0; i < fromCurrent.length; i++) {
          const index =
            currentIndex + i < items.length
              ? currentIndex + i
              : currentIndex + i - items.length;
          visible.push({ index, item: fromCurrent[i] });
        }
      } else {
        const lim = Math.min(items.length, visibleNumber);
        for (let i = 0; i < lim; i++) {
          visible.push({ index: i, item: items[i] });
        }
      }
    }
    return visible;
  }

  static navigationLeft = (e, visible, items, visibleNumber, setStateVisibles) => {
    const index = visible[0].index === 0 ? items.length - 1 : visible[0].index - 1;

    visible.pop();
    visible.unshift({ index, item: items[index] });
    setStateVisibles && typeof setStateVisibles === "function" && setStateVisibles(visible)
  }

  static navigationRight = (e, visible, items, visibleNumber, setStateVisibles) => {
    const last = visible[visible.length - 1];

    const index = last.index === items.length - 1 ? 0 : last.index + 1;

    visible.shift();
    visible.push({ index, item: items[index] });
    setStateVisibles && typeof setStateVisibles === "function" && setStateVisibles(visible)
  }

  static getDataUtilFocusDynamicBox(e, visible, visibleNumber) {
    const sizeVisible = visible.length < visibleNumber ? 5 : visible.length;
    const idNumberNowFocused = parseInt(e.target.id.split('_').pop());
    const firstValueNowFocused = e.target.id.split('_')[0];

    return {sizeVisible, idNumberNowFocused, firstValueNowFocused};
  }

  static getCanUseVisibleNumber(completeItems, visibleNumber, ribbonType, firstValueNowFocused) {
    return completeItems.length < visibleNumber
      || (Utils.isMusicRibbon(ribbonType)
        || firstValueNowFocused.includes("temporada") )
  }


  static handleKeyRightFocusDynamicBox(e, visible, completeItems, visibleNumber, setStateVisibles, ribbonType) {
    e.preventDefault();
    const {idNumberNowFocused, firstValueNowFocused} = GeneralRibbonUtils.getDataUtilFocusDynamicBox(e, visible, visibleNumber);
    const idNumberNextFocused = idNumberNowFocused + 1; // id del siguiente elemento al que hay que agregar foco dinámico
    const classNameNextFocus = `.focus_${firstValueNowFocused}_${idNumberNextFocused}`; // elemento al que se le pone el foco dinámico.
    const classNameStaticFocus = `.focus_${firstValueNowFocused}_${idNumberNowFocused}`; // elemento al que se le pone el foco estático.
    const canUseVisibleNumber = GeneralRibbonUtils.getCanUseVisibleNumber(completeItems, visibleNumber, ribbonType, firstValueNowFocused)

    const endElement = canUseVisibleNumber ? visibleNumber : visibleNumber - 1; // se verifica sí el foco se debe detener antes del último elemento o no.

    if (idNumberNowFocused === endElement || idNumberNowFocused >= completeItems.length) {
      GeneralRibbonUtils.navigationRight(e, visible, completeItems, visibleNumber, setStateVisibles);
      window.SpatialNavigation.focus(classNameStaticFocus);
    }else {
      const reviewElement = document.querySelector(classNameNextFocus);
      reviewElement && window.SpatialNavigation.focus(classNameNextFocus);
      !reviewElement && window.SpatialNavigation.focus(classNameStaticFocus)
    }

  }


  static handleKeyLeftFocusDynamicBox(e, visible, completeItems, visibleNumber, setStateVisibles, ribbonType) {
    e.preventDefault();
    const { idNumberNowFocused, firstValueNowFocused} = GeneralRibbonUtils.getDataUtilFocusDynamicBox(e, visible, visibleNumber);
    const idNumberNextFocused = idNumberNowFocused - 1; // id del siguiente elemento al que hay que agregar foco dinámico
    const classNameNextFocus = `.focus_${firstValueNowFocused}_${idNumberNextFocused}`; // elemento al que se le pone el foco dinámico.
    const classNameStaticFocus = `.focus_${firstValueNowFocused}_${idNumberNowFocused}`; // elemento al que se le pone el foco estático.
    const canUseVisibleNumber = GeneralRibbonUtils.getCanUseVisibleNumber(completeItems, visibleNumber, ribbonType, firstValueNowFocused)

    const endElement = canUseVisibleNumber ? visibleNumber : visibleNumber - 1; // se verifica sí el foco se debe detener antes del último elemento o no.

    if(idNumberNowFocused <= endElement && idNumberNowFocused > 1) {
      const reviewElement = document.querySelector(classNameNextFocus);
      reviewElement && window.SpatialNavigation.focus(classNameNextFocus);
      !reviewElement && window.SpatialNavigation.focus(classNameStaticFocus)
    }else if(idNumberNowFocused === 1) {
      GeneralRibbonUtils.navigationLeft(e, visible, completeItems, visibleNumber, setStateVisibles);
      window.SpatialNavigation.focus(classNameStaticFocus);
    }
  }

  static getVisibleNumber = ({ type, visibleNumber = 0, isMusic = false }) => {
    let number;
    switch (type) {
      case HIGHLIGHT:
        number = VISIBLE_NUMBER_HIGHLIGHT;
        break;
      case PREMIUM:
        number = VISIBLE_NUMBER_PREMIUM;
        break;
      case CATEGORY:
        number = VISIBLE_NUMBER_CATEGORY;
        break;
      case TALENTS:
        number = VISIBLE_NUMBER_TALENTS;
        break;
      case MOREPOPULAR:
        number = VISIBLE_NUMBER_POPULAR;
        break;
      case MORETOP:
        number = VISIBLE_NUMBER_TOP;
        break;
      case MUNDIALSOCCERMATCHER:
        number = VISIBLE_NUMBER_MUNDIAL_SOCCERMATCHER;
        break;
      case MUNDIALPLAYERS:
        number = VISIBLE_NUMBER_PLAYERS;
        break;
      default:
        number = isMusic ? visibleNumber : 5 ;
    }
    return number;
  }

  static getPlacesMovingToLeft = (type) => {
    let number;
    switch (type) {
      case HIGHLIGHT:
        number = 1;
        break;
      default:
        number = 0;
    }
    return number;
  }

  static getPosition = (items, title) => {
    for (let i = 0; i < items.length; i++) {
      if (items[i].title === title) return i;
    }
    return undefined;
  }

  static getPositionMundial = (items, id) => {
    for (let i = 0; i < items.length; i++) {
      if (items[i].id === id) return i;
    }
    return undefined;
  }

  static getIgnoreSeenLastByRibbonUrl = (url) => {
    if (!url) return false;
    url = url.toLowerCase();
    switch (true) {
      case url.indexOf('/services/user/seen') !== -1:
      case url.indexOf('/services/user/favorited') !== -1:
      case url.indexOf('/services/user/purchasedactive') !== -1:
        return true;
      default:
        return false;
    }
  }

  static getBadgesHTML = (badgesUserType, node_item) => {
    let badges = '';
    let node_item_provider = node_item && node_item.provider;
    if (badgesUserType[node_item_provider] === undefined) {
      node_item_provider = 'default';
    }

    if (
      node_item_provider &&
      badgesUserType &&
      badgesUserType[node_item_provider]
    ) {
      let formatTypes = node_item.format_types
        ? node_item.format_types
        : [];

      if (formatTypes.length === 2 && formatTypes[0] === "est" && formatTypes[1] === "ppe") {
        formatTypes = formatTypes.reverse()
      }

      const badge_provider = badgesUserType[node_item_provider];
      for (let i = 0; i < formatTypes.length; i++) {
        if (
          badge_provider[formatTypes[i]] &&
          badge_provider[formatTypes[i]][node_item.badgeType]
        ) {
          const data = badge_provider[formatTypes[i]][node_item.badgeType];
          for (let i = 0; i < data.length; i++) {
            badges += data[i].render;
          }
        }
      }
    }
    return badges;
  }

  static handleRecordingSeries = async ({ timeUsed, actions, handleDeleteFromRibbonRecordings = null, data = {}}) =>{
    let series = [];
    const { episodes = null } = actions;
    if (episodes) {
      const result = await NpvrUploader.listByCompleteUrl(episodes);
      const recordings = NpvrUploader.filterErrorRecordings(result.recordings);
      if (Array.isArray(recordings) && recordings.length > 0) {
        series = recordings.map(record => {
          const {
            channel: { image, group_id: groupId, event: { ext_eventimage_name = null, name: title, group_id, description, date_begin, id: event_id = null, event_alf_id, id_composite } },
            pack_id: packId,
            actions,
            status,
            date,
            record_id
          } = record;
          const limit = ChannelSingleton.getNpvrStorage(groupId); // minutes
          const used = typeof timeUsed[packId] === 'number' ? timeUsed[packId] : 0; // minutes
          const dateOfRecord = new Dates().unix(date_begin); //Se sustiyute aqui date por date_begin para no afectar las demás grabaciones.
          const dateOfEvent = date_begin;
          return {
            isEpisode: true,
            group_id: group_id,
            event_id,
            channel_id: record.channel.id,
            cover: ext_eventimage_name || image.replace('https://', 'http://'),
            title,
            titleEpisode: `${record.channel.name} Ep. ${record.channel.event.ext_episode_id}`,
            description: description,
            node: 'myRecords',
            record_id: record_id,
            status,
            actions: actions,
            used,
            limit,
            isRecord: true,
            dateOfRecord,
            dateOfEvent,
            date_begin: record.channel && record.channel.event ? record.channel.event.date_begin : null,
            date_end: record.channel && record.channel.event ? record.channel.event.date_end : null,
            duration: record.channel && record.channel.event ? record.channel.event.duration : null,
            liveref: record.channel && record.channel.liveref ? record.channel.liveref : null,
            event_alf_id,
            id_composite,

            clickHandler: (e) => {
              this.props.handleRecordingPlay(group_id, title, actions, (record.channel.event ? record.channel.event : null));
            }
          };
        });
        const limitItemsByRibbon = 2;
        const ribbons = GeneralRibbonUtils.parseArrayToArrayOfArrayByLimit(series, limitItemsByRibbon);
        store.dispatch(showModal({
          modalType: MODAL_RECORD_SERIES_CONTENT,
          modalProps: {
            title: series[0].title,
            recordings: ribbons,
            handleDeleteFromRibbonRecordings,
            listSerieParams: {timeUsed, actions, handleDeleteFromRibbonRecordings, data}
          }
        }));
        return series && Array.isArray(series) ? series.length : 0;
      }
    }
  };

  static parseArrayToArrayOfArrayByLimit(series = [], limit) {
    return GeneralRibbonUtils.splitArrayInArrays(series, limit);
  }

  static splitArrayInArrays(arrayToSplit, numberItemsBySubarray) {

    var result = [];
    let currentSubarray = {};

    // Empty array when 'to split' is not array
    if (!Array.isArray(arrayToSplit)) {
      currentSubarray = {
        id: 'recordings0',
        type: 'recordings',
        items: [],
      };
      result.push(currentSubarray);

      return result;
    }

    // If no limit, return original array
    if (isNaN(numberItemsBySubarray)) {
      currentSubarray = {
        id: 'recordings0',
        type: 'recordings',
        items: arrayToSplit,
      };

      result.push(currentSubarray);

      return result;
    }

    // If limit = 0, return original array
    if (numberItemsBySubarray === 0) {
      currentSubarray = {
        id: 'recordings0',
        type: 'recordings',
        items: arrayToSplit,
      };

      result.push(currentSubarray);

      return result;
    }

    // Si el length es menor o igual a limit, se regresa series tal cual
    // if(las series.length <= numberItemsBySubarray) return las series;

    let i, j, chunk;
    let ct = 0;
    for (i = 0, j = arrayToSplit.length; i < j; i += numberItemsBySubarray) {

      currentSubarray = {
        id: 'recordings' + (ct++),
        type: 'recordings',
        items: [],
      };

      chunk = arrayToSplit.slice(i, i + numberItemsBySubarray);
      currentSubarray.items = chunk;

      result.push(currentSubarray);
    }

    return result;
  };

  static isInvalidSize = (size) => {
    if (!size || !Array.isArray(size) || size.length !== 2) return true;
    const [width, height] = size;
    if (!Number.isInteger(width) || !Number.isInteger(height)) return true;
    if (width < 0 || height < 0) return true;
    if (width === 0 && height === 0) return true;
    return false;
  };

  static resizeImage = (url, size) => {
    if (!url) return '';
    if (GeneralRibbonUtils.isInvalidSize(size)) return url;

    const [width, height] = size;
    if (width === 0 && height > 0) return `${url}?impolicy=resize&vheight=${height}`;
    if (height === 0 && width > 0) return `${url}?impolicy=resize&vwidth=${width}`;
    return `${url}?size=${width}x${height}`;
  };

}

export default GeneralRibbonUtils



// WEBPACK FOOTER //
// ./src/components/RibbonNew/GeneralRibbonUtils.js